module.exports = __webpack_public_path__ + "static/media/Warung Kambiri.b9b1a455.png";